






















































































import { Component, Prop } from 'vue-property-decorator';
import SwScrollView from './scroll-view-dropdown.vue';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { CSSStyleOptions } from '@sonicwall/unified-ui-framework/src/shared/common-types';

@Component
export default class SwScrollViewScrollbar extends SwExtendedVue {
  @Prop({ type: Boolean, default: false })
  forVertical: boolean;

  @Prop({ type: String, default: 'light' })
  theme: string;

  @Prop({ type: Number, required: true })
  clientSize: number;

  @Prop({ type: Number, required: true })
  scrollSize: number;

  @Prop({ type: Number, required: true })
  zIndex: number;

  cssPrefix: string = 'sw-scroll-view-scrollbar';
  readyToShow: boolean = false;
  percentagePos: number = 0;

  get thumbMetrics() {
    if (!this.readyToShow || !this.scrollSize) { return null; }
    const selfSize = this.forVertical ? (this.$el as HTMLElement).offsetHeight : (this.$el as HTMLElement).offsetWidth;
    const thumbSize = Math.floor((selfSize * this.clientSize) / this.scrollSize);
    return {
      trackSize: selfSize,
      size: thumbSize,
      pos: (selfSize - thumbSize) * this.percentagePos,
    };
  }

  get thumbStyle(): CSSStyleOptions {
    if (!this.thumbMetrics) { return {}; }
    return {
      [this.forVertical ? 'height' : 'width']: `${this.thumbMetrics.size}px`,
      [this.forVertical ? 'top' : 'left']: `${this.thumbMetrics.pos}px`,
    };
  }

  updatePosition(percentagePos: number) {
    this.percentagePos = percentagePos;
  }

  onDragThumb(event: MouseEvent) {
    if (!this.thumbMetrics) { return; }

    event.preventDefault();

    const startPoint = this.forVertical ? event.clientY : event.clientX;
    const startPos = this.thumbMetrics.pos;
    const self = this;

    /** we know for sure the $parent is sw-scroll-view! */
    (this.$parent as SwScrollView).lockScrollbar = true;

    function onMouseMove(e: MouseEvent) {
      if (!self.thumbMetrics) { return; }
      e.preventDefault();
      const curPoint: number = self.forVertical ? e.clientY : e.clientX;
      let curPercentage: number = (startPos + (curPoint - startPoint)) / (self.thumbMetrics.trackSize - self.thumbMetrics.size);
      curPercentage = Math.max(Math.min(curPercentage, 1), 0);
      self.percentagePos = curPercentage;
      (self.$parent as SwScrollView).updatePercentagePosition(curPercentage, self.forVertical);
    }

    function onMouseUp(e: MouseEvent) {
      e.preventDefault();
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);

      (self.$parent as SwScrollView).lockScrollbar = false;
    }

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  }

  private mounted() {
    this.readyToShow = true;
  }
}
